import React, { useState } from 'react';
import './NoticeBanner.css';

const NoticeBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="notice-banner">
      <div className="notice-content">
        <span className="notice-icon">📢</span>
        <span className="notice-text">
          <strong>Important:</strong> We are currently upgrading our prayer & testimony system. 
          To submit a prayer request, testimony, or baptism request, please WhatsApp us on 
          <a 
            href="https://wa.me/27723187981?text=Hi%20JCAM%2C%20I%20would%20like%20to%20submit%20a%20prayer%20request." 
            className="notice-whatsapp-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            📱 072 318 7981
          </a>
        </span>
        <button className="notice-close" onClick={() => setIsVisible(false)}>✕</button>
      </div>
    </div>
  );
};

export default NoticeBanner;